/* eslint-disable */
import { useDocumentAuth } from '@/composables/useDocumentAuth';
import AuthService from '@/services/authService.ts';
import { obtainPersonalAccessToken } from '@/api/deepsign/personalAccessApi.ts';
import { useStorage } from '@vueuse/core';

export const setAuthorizationHeaders = async (
  headers: any,
  { preferAccessToken = false }: { preferAccessToken?: boolean } = {}
) => {
  const personalAccessConfig = useStorage(
    'personalAccessConfig',
    '',
    sessionStorage
  );
  const personalAccessConfigAsObject = personalAccessConfig.value
    ? JSON.parse(personalAccessConfig.value)
    : undefined;
  const { getDocumentToken } = useDocumentAuth();

  const documentToken =
    AuthService.isAuthenticated || getDocumentToken.value
      ? getDocumentToken.value
      : personalAccessConfigAsObject?.token;

  // Resources scoped to the logged-in identity (e.g. user preferences) never
  // authenticate with the document token, so callers can opt in to always
  // using the full access token when the user is authenticated, even if a
  // document token also exists (e.g. on the public document route).
  if (AuthService.isAuthenticated && (preferAccessToken || !documentToken)) {
    await AuthService.updateToken();
    if (AuthService.accessToken) {
      headers.Authorization = AuthService.fullAccessToken;
    }
    return Promise.resolve(headers);
  }

  if (documentToken) {
    headers.Authorization = `Bearer ${documentToken}`;
    if (!AuthService.isAuthenticated) {
      return Promise.resolve(headers);
    }
  }
  return Promise.resolve();
};

export const setPersonalAccessData = async (signKey: string, sid: string) => {
  const personalAccessConfig = useStorage(
    'personalAccessConfig',
    '',
    sessionStorage
  );

  try {
    const tokenResponse = await obtainPersonalAccessToken(signKey, {
      headers: {
        Authorization: `SID ${sid}`
      }
    });

    if (tokenResponse) {
      const accessConfig = {
        signKey: signKey,
        sid: sid,
        documentId: tokenResponse.data.documentId,
        token: tokenResponse.data.token
      };
      //set sid, signKey and documentId in the session storage
      personalAccessConfig.value = JSON.stringify(accessConfig);
    }
  } catch (error) {
    console.error('Failed to set personal access data: ', error);
  }
};
